import styled from 'styled-components'
import { colors } from '../../styles/vars/colors.style'
import { getStyles, textStylesConfig } from '../../styles/vars/textStyles.style'
import { AnimateScaleInWrapper } from '../animation/AnimateScaleIn/index.style'
import { RichTextMain } from '../RichText/index.style'

export const RegionMain = styled.div`
  position: relative;
`

export const RegionBackground = styled.div`
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
`

export const RegionContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: ${colors.light};
  z-index: 2;

  ${RichTextMain} {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    max-width: ${props =>
      `${props.maxWidth / textStylesConfig.heading1.size.max}em`};
    ${getStyles(textStylesConfig.heading1)}

    > * + * {
      margin-top: 0;
    }
  }

  ${AnimateScaleInWrapper} {
    display: inline-block;
    width: auto;
    width: ${props => props.aspectRatio * 0.8}em;
    height: 0.8em;
    margin: 0.05em 0.15em 0.05em 0.2em;
    ${getStyles(textStylesConfig.heading1)}
  }
`
